import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNote2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V14.8888L14.8888 21H3V3ZM4.5 4.5V19.5H13V13H19.5V4.5H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote2;
